module.exports = __webpack_public_path__ + "img/female-youngchild-foot.577e1525.svg";